import React, { useState, useEffect } from "react";
import "./AllForLucky.scss";

import { inject, observer } from "mobx-react";
import RootStore from "../../store/RootStore";
import { IUserLuckyOne } from "../../store/LuckyStore";
import { pushHistory, popHistory} from "../../utils/history";
import { IComponentLucky } from "../../component";
import Lucky from "./Lucky";
import LuckyPopup from "./LuckyPopup";
import MobileModal, { NAME_MOBILE_TEMPLATE } from "./MobileModal";
import LuckResultModal from "./LuckResultModal";
import MyLuckyModal from "./MyLuckyModal";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";

import moment from "moment";

import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";

const AllForLucky = (props: IComponentLucky) => {
  let { luckyStore, imStore, uiStore, wxuserStore } = props.rootStore!;
  const { lucky_id, mode, show_result, container, cid } = props;

  const [showEmpty, setShowEmpty] = useState(false);
  const [userRecord, setUserRecord] = useState(null as any);
  const [showMobileModal, setShowMobileModal] = useState(false);

  useEffect(() => {
    const onVoteStatus = (data: any) => {
      console.log(`on lucky change`, data);
      if (data && Number(data.lucky_id) == Number(lucky_id)) {
        let update = {} as {
          begin_at?: string;
          end_at?: string;
        };
        if (Number(data.status) == 1) {
          update.begin_at = moment().format("YYYY-MM-DD HH:mm:00");
        }
        if (Number(data.status) == 2) {
          update.end_at = moment().format("YYYY-MM-DD HH:mm:00");
        }
        luckyStore.updateData(lucky_id, update);
      }
    };

    if (lucky_id) {
      imStore.addMessageListener("lucky_status_change", onVoteStatus);
      luckyStore.checkLucky(lucky_id);
      if (!wxuserStore.user.is_mock) {
        luckyStore.checkUserLucky(lucky_id);
      }
    } else {
      setShowEmpty(true);
    }

    return () => {
      imStore.removeMessageListener("lucky_status_change", onVoteStatus);
    };
  }, [lucky_id]);

  const onLucky = () => {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return false;
    }
    return luckyStore.addRecord(lucky_id).then((apiResult: any) => {
      if (Number(apiResult.code) == 201101) {
        // uiStore.showToast({
        //   content: '您已达到最大中奖次数'
        // });
      }

      if (Number(apiResult.code) == 201115) {
        uiStore.showToast({
          content: "活动未开始",
        });
      }

      if (Number(apiResult.code) == 201116) {
        uiStore.showToast({
          content: "活动已结束",
        });
      }

      if (Number(apiResult.code) == 201103) {
        uiStore.showToast({
          content: "您的抽奖次数已用完",
        });
      }

      if (Number(apiResult.code) == 201102) {
        uiStore.showToast({
          content: "请稍等，您的上次抽奖还未结束",
        });
      }

      if (
        Number(apiResult.code) == 200 &&
        apiResult.data &&
        apiResult.data.id
      ) {
        setUserRecord(apiResult.data);
      }

      return apiResult;
    });
  };

  const onShowPhone = () => {
    setShowMobileModal(true);
  };

  const data = luckyStore.getLucky(lucky_id);

  const checkHideLucky = (force?: boolean) => {
    if (mode == "dialog" || force) {
      let event = new Event("lucky_hide");
      event.data = cid;
      window.dispatchEvent(event);

      let pendent = new Event("PENDENT_CHANGE");
      pendent.buttons = [];
      pendent.action = "event";
      window.dispatchEvent(pendent);
    }
  };

  const [showAll, setShowAll] = useState(false);
  const onShowAllLuck = () => {
    setShowAll(true);
    checkHideLucky();

    pushHistory("luckyall", ()=>{
      setShowAll(false);
    });
  };

  const [showMyLuck, setShowMyLuck] = useState(false);
  const onShowMyLuck = () => {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return false;
    }

    // 这里要判断一下当前是否有我的奖品
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      let mainIndex = new Event("main-index");
      mainIndex.data = {
        id: 5,
      };
      window.dispatchEvent(mainIndex);

      let myIndex = new Event("my-index");
      myIndex.data = 6;
      window.dispatchEvent(myIndex);

      checkHideLucky(true);
    } else {
      setShowMyLuck(true);
    }
  };

  const renderLucky = () => {
    let renderList = [];
    if (data) {
      if (mode == "normal") {
        renderList.push(
          <Lucky
            data={data}
            mode={mode}
            show_result={show_result}
            onLucky={onLucky}
            onShowPhone={onShowPhone}
            onShowAllLuck={onShowAllLuck}
            onShowMyLuck={onShowMyLuck}
            key="normal"
            cid={cid}
          />
        );
      }

      renderList.push(
        <LuckyPopup
          data={data}
          mode={mode}
          show_result={show_result}
          onLucky={onLucky}
          onShowPhone={onShowPhone}
          onShowAllLuck={onShowAllLuck}
          onShowMyLuck={onShowMyLuck}
          key="popup"
          cid={cid}
        />
      );
    }

    return renderList;
  };

  const onFormSubmit = (data: any) => {
    if (userRecord && userRecord.id) {
      let formValue = {
        address: "",
      } as {
        [key: string]: string;
      };

      if (data && Object.keys(data).length) {
        Object.keys(data).forEach((key: string) => {
          let row = data[key];
          if (row && row.type == "form_input") {
            formValue.name = row.value;
          }
          if (row && row.type == "form_phone" && row.value && row.value.phone) {
            formValue.mobile = row.value.phone;
          }
        });
      }

      return luckyStore.doRecord(userRecord.id, formValue).then((res: any) => {
        if (res) {
          let { code } = res;
          if (code == 200) {
            uiStore.showToast({
              content: "领取成功，请留意客服电话",
            });
            setShowMobileModal(false);
            setUserRecord(null);
          }
          if (code == 200401) {
            uiStore.showToast({
              content: "已领取过",
            });
          }
          if (code == 200402) {
            uiStore.showToast({
              content: "系统错误，稍候再试",
            });
          }
        }

        return res;
      });
    }
  };

  return (
    <div
      className="all-for-lucky"
      style={{
        paddingBottom: container
          ? Number(container.top) + Number(container.bottom)
          : 0,
        display:mode == 'dialog' ? 'none' : 'block'
      }}
    >
      {showEmpty ? (
        <div className="lucky-empty">未找到抽奖活动</div>
      ) : (
        renderLucky()
      )}

      <MobileModal
        onClose={() => setShowMobileModal(false)}
        onSubmit={onFormSubmit}
        visible={showMobileModal}
        formTemplate={NAME_MOBILE_TEMPLATE(data)}
      />

      {showAll ? (
        <LuckResultModal
          onClose={() => {
            setShowAll(false);
            popHistory();
            if (mode == "dialog") {
              let event = new Event("PENDENT_CHANGE");
              event.action = "reset";
              window.dispatchEvent(event);
            }
            clearAllBodyScrollLocks();
          }}
          visible={showAll}
          luckId={lucky_id}
        />
      ) : null}

      {showMyLuck ? (
        <MyLuckyModal
          onClose={() => {
            setShowMyLuck(false);
            clearAllBodyScrollLocks();
          }}
          luckId={lucky_id}
        />
      ) : null}
    </div>
  );
};

export default inject("rootStore")(observer(AllForLucky));
